module.exports = __webpack_public_path__ + "km.7fdeb4b6.svg";